var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import useTaroHoverableEvents from '../_util/hooks/useTaroHoverableEvents';
let customRoutes = {};
let navigateTo = ({ url }) => {
    location.href = url;
};
// eslint-disable-next-line prefer-const
let navigateBack = () => {
    history.back();
};
export function initNavigatorComponent(opts) {
    customRoutes = opts.customRoutes;
    if (opts.navigateTo) {
        navigateTo = opts.navigateTo;
    }
}
function isAbsoluteUrl(url) {
    if (!url) {
        return false;
    }
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
const Navigator = (_a, ref) => {
    var { target = 'self', url: originUrl, openType = 'navigate', delta, appId, path, extraData, version, children, onSuccess, onFail } = _a, rest = __rest(_a, ["target", "url", "openType", "delta", "appId", "path", "extraData", "version", "children", "onSuccess", "onFail"]);
    const props = useTaroHoverableEvents(rest, 'navigator-hover');
    let targetUrl = originUrl;
    if (originUrl && !isAbsoluteUrl(originUrl)) {
        const urlObj = new URL(originUrl, 'http://0.0.0.0');
        const customRoute = customRoutes[urlObj.pathname];
        if (customRoute) {
            urlObj.pathname = customRoute;
        }
        targetUrl = urlObj.pathname + urlObj.search + urlObj.hash;
    }
    return (_jsx("a", Object.assign({}, props, { ref: ref, className: classNames('taro-nav', props.className), href: targetUrl, onClick: event => {
            event.preventDefault();
            if (target === 'self') {
                if (openType === 'navigate') {
                    navigateTo === null || navigateTo === void 0 ? void 0 : navigateTo({ url: targetUrl });
                }
                else if (openType === 'navigateBack') {
                    navigateBack === null || navigateBack === void 0 ? void 0 : navigateBack();
                }
            }
        } }, { children: children })));
};
export default forwardRef(Navigator);
